import React from 'react';
import { CardActions, ListButton, RefreshButton } from 'react-admin';

const EditActions = ({ basePath, data, resource }) => {
  return (
    <CardActions>
      <RefreshButton />
      <ListButton basePath={basePath} />
    </CardActions>
  );
};

export default EditActions;



// WEBPACK FOOTER //
// ./src/containers/SalesAdvisor/EditActions.js